import { render, staticRenderFns } from "./ClubPersonRel.vue?vue&type=template&id=7ae795ee&scoped=true"
import script from "./ClubPersonRel.vue?vue&type=script&lang=js"
export * from "./ClubPersonRel.vue?vue&type=script&lang=js"
import style0 from "./ClubPersonRel.vue?vue&type=style&index=0&id=7ae795ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae795ee",
  null
  
)

export default component.exports